import * as segmentio from 'rp-analytics';
import jQuery from 'jquery';

const section1 = {
    horse: 'Horses',
    jockey: 'Jockeys',
    owner: 'Owners',
    trainer: 'Trainers',
    course: 'Courses',
};

const stateName = {
    horse: 'raceHorseName',
    jockey: 'jokeyName',
    owner: 'ownerName',
    trainer: 'trainerName',
    course: 'courseName',
};

const state = {
    raceHorseName: '',
    jokeyName: '',
    ownerName: '',
    trainerName: '',
    courseName: '',
};

export const getHorseName = () => state.raceHorseName;

export default function analyticsPage(preloadedState = false) {
    const pathnameSplit = global.location.pathname.split('/');
    const type = pathnameSplit[2];

    if (preloadedState) {
        state.raceHorseName = type === 'horse' &&
            preloadedState.profile &&
            preloadedState.profile.horseName;

        state.jokeyName = type === 'jockey' &&
            preloadedState.profile &&
            preloadedState.profile.styleName;

        state.ownerName = type === 'owner' &&
            preloadedState.profile &&
            preloadedState.profile.styleName;

        state.trainerName = type === 'trainer' &&
            preloadedState.profile &&
            preloadedState.profile.styleName;

        state.courseName = type === 'course' &&
            preloadedState.profile &&
            preloadedState.profile.courseStyleName;
    }

    const newSection2 = jQuery('a.ui-tabs__tab_selected').text();
    // jQuery('a.pp-subTabs__tab_selected').text(); // on Sire's Stud Record; not used

    const commonTraits = segmentio.getCommonTraits();
    const oldSection2 = commonTraits && commonTraits[segmentio.TRAIT_SITE_SUB_SECTION_2];
    if (!newSection2 || newSection2 === oldSection2) return;

    segmentio.setCommonTraits({
        [segmentio.TRAIT_SITE_SECTION]: 'Profiles',
        [segmentio.TRAIT_SITE_SUB_SECTION_1]: section1[type],
        [segmentio.TRAIT_SITE_SUB_SECTION_2]: newSection2,
    });


    const pageTraits = {};

    if (state.raceHorseName) {
        pageTraits['Race Horse Name'] = state.raceHorseName;
    }

    if (state.jokeyName) {
        pageTraits['Jockey Name'] = state.jokeyName;
    }

    if (state.ownerName) {
        pageTraits['Owner Name'] = state.ownerName;
    }

    if (state.trainerName) {
        pageTraits['Trainer Name'] = state.trainerName;
    }

    if (state.courseName) {
        pageTraits['Course Name'] = state.courseName;
    }

    const permutiveProps = {
        profile: {
            type: section1[type],
            name: state[stateName[type]],
        },
    };

    const pageName = null; // not used for now
    segmentio.page(pageName, pageTraits, segmentio.page.DEFAULT_OPTIONS, permutiveProps);
}



// WEBPACK FOOTER //
// ./src/js/analyticsPage.js